export default "__VITE_ASSET__360474ed__";